var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row align-items-end" }, [
      _c("div", { staticClass: "col col-12 col-md-6 col-xl-4" }, [
        _c(
          "div",
          { staticClass: "form-group field" },
          [
            _c("c-input", {
              attrs: {
                type: "select",
                items: _vm.positions,
                label: "Для какой должности создать анкету",
              },
              model: {
                value: _vm.position,
                callback: function ($$v) {
                  _vm.position = $$v
                },
                expression: "position",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col col-12 col-md-auto" }, [
        _c(
          "div",
          { staticClass: "form-group apply" },
          [
            _c("c-button", {
              attrs: {
                color: "primary",
                label: "Применить",
                disabled: _vm.pending,
                pending: _vm.pending,
              },
              on: { click: _vm.apply },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }